module.exports = __webpack_public_path__ + "assets/img/detail-btn-b9b261ae.png";